import ResponsiveBackgroundImage from '../responsiveBg';

export default selector => {
    if ('undefined' === typeof selector) {
        selector = '.js-responsive-bg';
    }
    let elements = document.querySelectorAll(selector);
    for (let i=0; i<elements.length; i++) {
        new ResponsiveBackgroundImage(elements[i]);
    }
}



// WEBPACK FOOTER //
// ../src/scripts/modules/responsiveBg.js